import { FormattedMessage } from "react-intl";
import { useUser } from "./Components/UserProvider";
import Layout from "./Layout";
import Router from "./Router";
import Sidebar, { Menu } from "./Sidebar";

function HomeSidebar() {
	const user = useUser();
	
	return <Sidebar>
		<Menu icon="home" title={<FormattedMessage id="MENU.HOME" />}href="/dashboard" />
		<Menu icon="chalkboard-teacher" title={<FormattedMessage id="MENU.MENTORS" />} href="/mentor" />
		<Menu icon="user-friends" title={<FormattedMessage id="MENU.MENTEES" />} href="/mentee" />
		<Menu icon="envelope" title={<FormattedMessage id="MENU.MESSAGES" />} href="/chat" />
		<Menu icon="user-circle" title={<FormattedMessage id="PROFILE_INFORMATION" />} href="/profile" />
		{/*<Menu icon="cog" title="Account settings" href="/settings" />*/}
		<Menu icon="sign-out-alt" title={<FormattedMessage id="MENU.LOGOUT" />} href="/logout" />
	</Sidebar>;
}

export default function Home() {
	return <Layout sidebar={HomeSidebar}>
		<Router />
	</Layout>;
}